import { Reducer, AnyAction, Dispatch } from 'redux';
import { AuthzState } from './type';
import { fetchMyRoles } from '../../api/authz';
import { ApiError } from '../../api/request';

export const SET_AUTHZ = 'authz/set';

const defaultState: AuthzState = {
    loaded: false,
    roles: [],
    roleLabels: {},
    roleDescriptions: {},
    rules: [],
    groups: [],
    rbacEnabled: false,
};

const reducer: Reducer<AuthzState> = (
    state: AuthzState = defaultState,
    action: AnyAction,
) => {
    switch (action.type) {
        case SET_AUTHZ:
            return { ...state, ...action.payload, loaded: true };
        default:
            return state;
    }
};

const actions = {
    set(payload: Partial<AuthzState>) {
        return { type: SET_AUTHZ, payload };
    },
    load() {
        return async (dispatch: Dispatch) => {
            try {
                const data = await fetchMyRoles();
                dispatch(
                    actions.set({
                        roles: data.roles || [],
                        roleLabels: data.roleLabels || {},
                        roleDescriptions: data.roleDescriptions || {},
                        rules: data.rules || [],
                        groups: data.groups || [],
                        rbacEnabled: !!data.rbacEnabled,
                    }),
                );
            } catch (e) {
                // 后端不含 RBAC (404/405: 版本回退到未改造的构建) → 按老权限模型放开整站,
                // 由后端自己的管理员闸门兜底; 否则前端会把所有人锁死在"无权访问" (2026-09-14).
                const noRbacBackend =
                    e instanceof ApiError && (e.code === 404 || e.code === 405);
                // 其它失败 (网络抖动等) 按"无显式规则"处理: 菜单少显示总比把人锁在空白页好;
                // 真没权限时业务请求会被后端 20104 拦下.
                dispatch(
                    actions.set({
                        roles: noRbacBackend ? ['admin'] : [],
                        roleLabels: {},
                        roleDescriptions: {},
                        rules: noRbacBackend
                            ? [{ resources: ['*'], verbs: ['*'] }]
                            : [],
                        groups: [],
                        rbacEnabled: false,
                    }),
                );
            }
        };
    },
};

export default { reducer, actions };
